export default "__VITE_ASSET__Dfa5$4eW__"